"use strict";

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Card = _interopRequireDefault(require("reactstrap/lib/Card"));

var _CardHeader = _interopRequireDefault(require("reactstrap/lib/CardHeader"));

var _CardBody = _interopRequireDefault(require("reactstrap/lib/CardBody"));

var _Collapse = _interopRequireDefault(require("reactstrap/lib/Collapse"));

var _icon = _interopRequireDefault(require("../icon/icon"));

var _icons = require("../lib/icons");

var _utils = require("../lib/utils");

require("./accordion.css");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Accordion = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Accordion, _React$Component);

  var _super = _createSuper(Accordion);

  function Accordion() {
    var _context;

    var _this;

    (0, _classCallCheck2["default"])(this, Accordion);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat["default"])(_context = [this]).call(_context, args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onItemChange", function (item) {
      var _this$props = _this.props,
          activeItemId = _this$props.activeItemId,
          onItemChange = _this$props.onItemChange;
      var id = null;

      if (item.id !== activeItemId) {
        id = item.id;
      }

      onItemChange(id);
    });
    return _this;
  }

  (0, _createClass2["default"])(Accordion, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          dataTestId = _this$props2.dataTestId,
          items = _this$props2.items,
          activeItemId = _this$props2.activeItemId;
      return /*#__PURE__*/_react["default"].createElement("div", {
        "data-testid": dataTestId,
        className: (0, _utils.gatherClasses)(this.props, "oui-accordion")
      }, (0, _map["default"])(items).call(items, function (item) {
        return /*#__PURE__*/_react["default"].createElement(_Card["default"], {
          key: item.id,
          className: (0, _utils.gatherClasses)(null, "oui-accordion-card", item.id === activeItemId ? "oui-card-expanded" : "oui-card-collapsed")
        }, /*#__PURE__*/_react["default"].createElement(_CardHeader["default"], {
          className: "oui-accordion-card-header",
          onClick: function onClick() {
            return _this2.onItemChange(item);
          }
        }, item.icon ? /*#__PURE__*/_react["default"].isValidElement(item.icon) ? /*#__PURE__*/_react["default"].cloneElement(item.icon, {
          className: (0, _utils.gatherClasses)(null, "oui-mr-3", item.icon.props.className)
        }) : /*#__PURE__*/_react["default"].createElement(_icon["default"], item.icon) : null, /*#__PURE__*/_react["default"].createElement("span", {
          className: "oui-title oui-text-truncate"
        }, item.title), /*#__PURE__*/_react["default"].createElement(_icon["default"], {
          src: _icons.ArrowRight,
          width: "12px",
          height: "12px",
          clickable: true,
          onClick: _this2.onCollapseToggle,
          className: (0, _utils.gatherClasses)(null, "oui-card-collapse-toggler")
        })), /*#__PURE__*/_react["default"].createElement(_Collapse["default"], {
          isOpen: item.id === activeItemId
        }, /*#__PURE__*/_react["default"].createElement(_CardBody["default"], {
          className: (0, _utils.gatherClasses)(null, "oui-accordion-card-body", item.noGutter ? "oui-p-0" : null)
        }, (0, _utils.isFunction)(item.component) && item.component())));
      }));
    }
  }]);
  return Accordion;
}(_react["default"].Component);

Accordion.propTypes = {
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string.isRequired,
    title: _propTypes["default"].string,
    icon: _propTypes["default"].any,
    component: _propTypes["default"].func,
    noGutter: _propTypes["default"].bool
  })),
  activeItemId: _propTypes["default"].string,
  onItemChange: _propTypes["default"].func,
  dataTestId: _propTypes["default"].string
};
Accordion.defaultProps = {
  items: [],
  onItemChange: function onItemChange() {},
  dataTestId: "orion-accordion"
};
Accordion.displayName = "OrionAccordion";
var _default = Accordion;
exports["default"] = _default;